import { rankifierLogo } from "@datagame/ui";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames/bind";

import { RenderableDestinations } from "../../../../contexts/rankifier/rankifierDestinations";
import { useRankifierDestinations } from "../../../../hooks/useRankifierDestinations";
import { useGlobalConfiguration } from "../../../../hooks/useGlobalConfiugration";

import styles from "./Destination.module.scss";

const cx = classNames.bind(styles);

interface DestinationProps {
  kind: RenderableDestinations;
  className?: string;
  cardClassName?: string;
}

export const Destination = ({ kind }: DestinationProps) => {
  const { hideDatagameBranding } = useGlobalConfiguration();
  const { ref, toRender } = useRankifierDestinations().refs[kind];
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });
  const { current: wrapperEl } = ref;

  const calculatePosition = (index: number) => {
    const style: {
      top?: string;
      left?: string;
      right?: string;
      bottom?: string;
    } = { top: "0px", left: "0px" };

    if (kind === "selected") {
      const wrapperWidth = wrapperEl?.getBoundingClientRect().width ?? 0;
      const firstSocketWidth =
        wrapperEl?.querySelector(`#destination-selected-${index}`)?.getBoundingClientRect().width ?? 0;
      const padding = isDesktop ? 8 : 4;
      const naturalOffset = firstSocketWidth + padding;
      const perfectFitModifier = (wrapperWidth - firstSocketWidth - padding * 2) / (toRender - 1);
      const modifier = wrapperWidth > naturalOffset * toRender ? naturalOffset : perfectFitModifier;
      style.left = `${modifier * index + padding}px`;
    }

    return style;
  };

  return (
    <div ref={ref} className={cx(kind, `cards-${toRender}`)}>
      {!hideDatagameBranding && (
        <img className={cx("areaImage", "transparentLogo")} src={rankifierLogo} alt="rankifier transparent logo" />
      )}
      {Array.from({ length: toRender }).map((_, index) => (
        // eslint-disable-next-line react/no-unknown-property
        <div
          style={calculatePosition(index)}
          key={index}
          id={`destination-${kind}-${index}`}
          className={styles.destination}
        >
          {!hideDatagameBranding && (
            <img
              className={cx("destinationImage", "transparentLogo")}
              src={rankifierLogo}
              alt="rankifier transparent logo"
            />
          )}
        </div>
      ))}
    </div>
  );
};
